/**
 * Package Type definitions for Dynamic Packages
 *
 * REPEATING: Package designed for 1 night but can be booked for multiple nights.
 *            Experiences from day 0/1 repeat across the stay.
 *            - Day 0 experiences available on all days excluding checkout
 *            - Day 1 experiences available on all days except day 0
 *
 * FLEXIBLE:  Multi-day package with experiences mapped to specific days.
 *            Each day has its own set of experiences.
 */
export const PackageType = {
  REPEATING: 'repeating',
  FLEXIBLE: 'flexible',
} as const;

export type PackageType = (typeof PackageType)[keyof typeof PackageType];
